module.exports = __webpack_public_path__ + "static/media/button-app-store@3x.09812d20.png";